<template>
  <div>
    <!-- items:
    <pre>{{ items}}</pre> -->
    <form>
      <div class="md:flex md:mx-10 mb-10">
        <div class="md:w-2/3">
          <v-card class="md:mr-4 p-4" color="#F2F8FE">
            <div class="font-bold">PRINCIPAL BUYER</div>
            <div class="md:flex">
              <div
                class="w-1/3 border-2 border-gray-300 mr-2"
                :class="
                  no_firstname
                    ? 'border-4 border-red-400'
                    : 'border-2 border-gray-300'
                "
              >
                <v-text-field
                  clearable
                  :error-messages="firstnameErrors"
                  :counter="20"
                  required
                  @input="$v.firstname.$touch()"
                  @blur="$v.firstname.$touch()"
                  placeholder="First Name"
                  type="text"
                  class="bg-white px-4 py-1 w-full"
                  v-model="firstname"
                />
              </div>
              <div
                class="w-1/3 border-2 border-gray-300 mr-2"
                :class="
                  no_lastname
                    ? 'border-4 border-red-400'
                    : 'border-2 border-gray-300'
                "
              >
                <v-text-field
                  clearable
                  :error-messages="lastnameErrors"
                  :counter="20"
                  required
                  @input="$v.lastname.$touch()"
                  @blur="$v.lastname.$touch()"
                  placeholder="Last Name"
                  type="text"
                  class="bg-white px-4 py-1 w-full"
                  v-model="lastname"
                />
              </div>
              <div class="w-1/3 border-2 border-gray-300 mr-2">
                <v-text-field
                  clearable
                  placeholder="Suffix"
                  type="text"
                  class="bg-white px-4 py-1 w-full"
                  v-model="suffix"
                />
              </div>
            </div>
          </v-card>
          <v-card class="md:mr-4 px-4" color="#F2F8FE">
            <div class="font-bold">SPOUSE OR CO-BORROWER</div>
            <div class="md:flex">
              <div class="border-2 border-gray-300 mr-2 md:flex">
                <v-text-field
                  clearable
                  placeholder="First Name"
                  v-model="co_firstname"
                  type="text"
                  class="bg-white px-4 py-1 w-full"
                />
                <v-text-field
                  clearable
                  placeholder="Last Name"
                  v-model="co_lastname"
                  type="text"
                  class="bg-white px-4 py-1 w-full"
                />
                <v-text-field
                  clearable
                  placeholder="Suffix"
                  type="text"
                  class="bg-white px-4 py-1 w-full"
                  v-model="co_suffix"
                />
              </div>
            </div>
          </v-card>
          <v-card class="md:mr-4 px-4 py-2" color="#F2F8FE">
            <div class="font-bold">NEW CONTACT INFORMATION TO REGISTER</div>
            <div class="md:flex">
              <div
                class="border-2 mr-2"
                :class="
                  no_email
                    ? 'border-4 border-red-400'
                    : 'border-2 border-gray-300'
                "
              >
                <v-text-field
                  v-model="email"
                  :error-messages="emailErrors"
                  label="E-mail"
                  required
                  class="bg-white px-4 w-full"
                  @input="$v.email.$touch()"
                  @blur="$v.email.$touch()"
                ></v-text-field>
              </div>

              <div
                class="border-2 border-gray-300 mr-2"
                :class="
                  no_mobile
                    ? 'border-4 border-red-400'
                    : 'border-2 border-gray-300'
                "
              >
                <v-text-field
                  v-model="mobile"
                  :error-messages="mobileErrors"
                  :counter="11"
                  label="Mobile Number"
                  required
                  class="bg-white px-4 pt-2 w-full"
                  @input="$v.mobile.$touch()"
                  @blur="$v.mobile.$touch()"
                ></v-text-field>
              </div>
            </div>
          </v-card>
          <v-card class="md:mr-4 px-4 my-2 py-2" color="#F2F8FE">
            <div class="font-bold">MOLDEX PROPERTY INFORMATION</div>
            <div>
              <div class="w-full my-2 border-2 mr-2 border-gray-300">
                <v-autocomplete
                  class="bg-white px-4"
                  label="Project"
                  :items="items"
                  item-text="project"
                  item-value="project"
                  v-model="project"
                  autocomplete
                ></v-autocomplete>
              </div>
              <div class="sm:flex w-full">
                <div class="w-1/3 border-2 mr-2 border-gray-300">
                  <input
                    required
                    class="w-full py-2 px-4 bg-white"
                    type="text"
                    placeholder="Phase"
                    v-model="phase"
                  />
                </div>
                <div class="w-1/3 border-2 mr-2 border-gray-300">
                  <input
                    required
                    class="w-full py-2 px-4 bg-white"
                    type="text"
                    placeholder="Block"
                    v-model="block"
                  />
                </div>
                <div class="w-1/3 border-2 border-gray-300">
                  <input
                    class="w-full py-2 px-4 bg-white"
                    type="text"
                    placeholder="Lot"
                    v-model="lot"
                  />
                </div>
              </div>
              <!-- Floor & Unit No. -->
              <div class="sm:flex w-full my-2">
                <div class="w-1/2 border-2 border-gray-300 mr-2">
                  <input
                    class="w-full py-2 px-4 bg-white"
                    type="text"
                    placeholder="Building"
                    v-model="building"
                  />
                </div>
                <div class="w-1/2 border-2 border-gray-300">
                  <input
                    class="w-full mr-2 py-2 px-4 bg-white"
                    type="text"
                    placeholder="Floor/Unit No."
                    v-model="floor"
                  />
                </div>
              </div>
              <div class="sm:flex w-full">
                <div
                  class="w-full border-2 border-gray-300"
                  :class="no_contract_number ? 'border-4 border-red-400' : ''"
                >
                  <v-text-field
                    v-model="contractnumber"
                    :error-messages="cnErrors"
                    :counter="13"
                    class="bg-white px-4 w-full"
                    label="Contract Number"
                    required
                    @input="$v.contractnumber.$touch()"
                    @blur="$v.contractnumber.$touch()"
                  ></v-text-field>
                </div>
              </div>
            </div>
          </v-card>
        </div>
        <div class="boxRight p-4 md:w-1/3">
          <div class="font-bold">
            {{ notes[0]["text"] }}
          </div>
          <input
            ref="file"
            type="file"
            style="display: none"
            @change="onUpload"
          />
          <div class="bg-white p-4">
            <div v-for="(item, i) in instructions" :key="i">
              <li>
                {{ item.text }}
              </li>
            </div>
          </div>
          <div class="my-4">
            <div class="py-2" v-for="(item, i) in attachments" :key="i">
              <div>
                {{ item.label }}
              </div>
              <v-btn
                @click="startUpload(item.id)"
                class="w-full justify-start"
              >
                <div class="flex justify-between items-center">
                  <div>{{ item.file ? item.file.name : "Attach File" }}</div>
                  <div>
                    <v-icon> mdi-attachment </v-icon>
                  </div>
                </div>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-10 md:flex w-full">
        <v-btn class="py-6 w-1/2 md:mr-2" color="red" dark @click="cancel">
          Cancel
        </v-btn>
        <v-btn
          @click="on_submit_bis_form"
          class="py-6 w-1/2"
          color="#19196B"
          dark
        >
          Submit My Updated Buyer's Information Sheet
        </v-btn>
      </div>
    </form>
    <v-dialog
      v-model="success_dialog"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <div class="p-10 bg-white">
        <BisMessage />
        <v-btn class="w-full" small @click="bis_done"> Ok </v-btn>
      </div>
    </v-dialog>
    <v-snackbar top v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { projects } from "./Projects.js";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import BisMessage from "./BisMessage.vue";

export default {
  data() {
    return {
      no_email: false,
      no_lastname: false,
      no_firstname: false,
      no_mobile: false,
      no_contract_number: false,
      snackbarText: "",
      snackbar: false,
      success_dialog: false,
      currentAttachmentId: null,
      attachments: [
        {
          id: 1,
          label: "Upload ID 1",
          file: null,
        },
        {
          id: 2,
          label: "Upload ID 2",
          file: null,
        },
        {
          id: 3,
          label: "Upload Signatures",
          file: null,
        },
      ],
      items: projects,
      firstname: null,
      lastname: null,
      suffix: null,
      co_suffix: null,
      email: "",
      mobile: "",
      contractnumber: null,

      co_firstname: null,
      co_lastname: null,
      project: "",
      phase: null,
      block: null,
      lot: null,
      building: null,
      floor: null,

      notes: [
        {
          text: "Attach the following documents:",
        },
      ],
      instructions: [
        {
          text: "Submit a copy of your two (2) photo-bearing valid government issued IDs (of all Buyers)",
        },
        {
          text: "Submit a copy of your three (3) specimen signatures with the current date written (of all Buyers)",
        },
      ],
      dialog: false,
      dialogMessage:
        "I certify the information provided is true and correct. I understand that if my contact information shall change, it will be my responsibility to submit a new Buyers Information Sheet to Moldex Head Office for updating. I hereby bind myself that any notice, letter and/or correspondence sent to my contact numbers, or postal address shall be considered as validly served to me. I understand the postal address of the Principal Buyer mentioned will be the address indicated in the notices sent to me and indicated in my official documents such as the Contract To Sell, Deed of Absolute Sale, and other pertinent documents. I expressly waive my right under any confidentiality laws, including but not limited to R.A. No. 10173 (Data Privacy Act of 2012). Likewise, I hereby authorize Moldex and its employees to make use of all my personal data and they may divulge the same to their agents, sales personnel and others. I hereby hold Moldex Realty, Inc./Moldex Land, Inc. free and harmless from any liability that may arise from the collection, processing, storing, destruction and disclosure of any information regarding my purchased property/unit with Moldex.",
    };
  },

  mixins: [validationMixin],
  validations: {
    firstname: { required, maxLength: maxLength(20) },
    lastname: { required, maxLength: maxLength(20) },
    mobile: { required, maxLength: maxLength(11) },
    contractnumber: { required, maxLength: maxLength(13) },
    email: { required, email },
    select: { required },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },
  components: { BisMessage },
  methods: {
    startUpload(id) {
      this.$refs.file.click();
      this.currentAttachmentId = id;
    },
    onUpload(e) {
      const file = e.target.files[0];
      if (!file || this.currentAttachmentId === null) {
        return;
      }
      this.attachments.find((a) => a.id === this.currentAttachmentId).file =
        file;
    },
    cancel() {
      this.$router.push("/login");
    },
    on_submit_bis_form() {
      this.no_email = false;
      this.no_firstname = false;
      this.no_lastname = false;
      this.no_mobile = false;
      this.no_contract_number = false;
      if (
        this.firstname &&
        this.lastname &&
        this.contractnumber &&
        this.mobile &&
        this.email
      ) {
        const data = new FormData();
        data.append("contractnumber", this.contractnumber);
        data.append("firstname", this.firstname);
        data.append("lastname", this.lastname);
        data.append("email", this.email);
        data.append("mobile", this.mobile);

        data.append("co_firstname", this.co_firstname);
        data.append("co_lastname", this.co_lastname);
        data.append("project", this.project);
        data.append("phase", this.phase);
        data.append("block", this.block);
        data.append("lot", this.lot);
        data.append("building", this.building);
        data.append("floor", this.floor);

        for (const attachment of this.attachments) {
          data.append(attachment.id.toString(), attachment.file);
        }
        axios
          .post("/bis/submit", data)
          .then((res) => {
            if (res.data.status) {
              this.success_dialog = true;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.snackbar = true;
        this.snackbarText = "Please complete the required fields.";
        if (!this.email) this.no_email = true;
        if (!this.firstname) this.no_firstname = true;
        if (!this.lastname) this.no_lastname = true;
        if (!this.mobile) this.no_mobile = true;
        if (!this.contractnumber) this.no_contract_number = true;
      }
    },
    bis_done() {
      this.$router.push("/login");
    },
    clear() {
      this.$v.$reset();
      this.firstname = "";
      this.email = "";
      this.select = null;
      this.checkbox = false;
    },

    insert_axios() {
      let data = {
        user_id: 123123,
        appointment_purposes: "BIS",
        status_id: 1,
        remarks_id: 1,
        classification_id: 7,
        department_id: 10,
        subject: "BIS",
        contract_number: this.contractnumber,
        property:
          this.phase + " " + this.block + " " + this.lot + " " + this.building,
        customer_code: "",
        buyer_name: this.firstname + " " + this.lastname,
        firstname: this.firstname,
        lastname: this.lastname,
        suffix: this.suffix,
        co_firstname: this.co_firstname,
        co_lastname: this.co_lastname,
        co_suffix: this.co_suffix,
        email: this.email,
        mobile: this.mobile,
        project: this.project,
        phase: this.phase,
        block: this.block,
        lot: this.lot,
        building: this.building,
        floor: this.floor,
        contractnumber: this.contractnumber,
      };

      // Validation to ensure data is not null or empty
      for (let key in data) {
        if (!data[key]) {
          alert("System is currently unavailable. Please try again.");
          console.log(`Validation failed: ${key} is null or empty`);
          return;
        }
      }

      axios.post("/tickets/add", data).then((res) => {
        if (res.data.status) {
          alert(
            "Your form has been submitted successfully. We will get back to you as soon as possible."
          );
        }
      }).catch((err) => {
        console.log(err);
      });
    },
  },
  computed: {
    firstnameErrors() {
      const errors = [];
      if (!this.$v.firstname.$dirty) return errors;
      !this.$v.firstname.maxLength &&
        errors.push("First name must be at most 20 characters long");
      !this.$v.firstname.required && errors.push("First Name is required.");
      return errors;
    },
    lastnameErrors() {
      const errors = [];
      if (!this.$v.lastname.$dirty) return errors;
      !this.$v.lastname.maxLength &&
        errors.push("Last name must be at most 20 characters long");
      !this.$v.lastname.required && errors.push("Last name is required.");
      return errors;
    },
    cnErrors() {
      const errors = [];
      if (!this.$v.contractnumber.$dirty) return errors;
      !this.$v.contractnumber.maxLength &&
        errors.push("Contract number must be at most 13 characters long");
      !this.$v.contractnumber.required &&
        errors.push("Contract number is required.");
      return errors;
    },
    mobileErrors() {
      const errors = [];
      if (!this.$v.mobile.$dirty) return errors;
      !this.$v.mobile.maxLength &&
        errors.push("Mobile number must be at most 11 characters long");
      !this.$v.mobile.required && errors.push("Mobile number is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
  },
};
</script>

<style scoped>
.boxRight {
  background: #e9967a;
}
</style>